import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

interface Props {
  iconVisible: boolean
  label: string
  disabled?: boolean
  onClick?: () => void
}

const NavigationLink = ({ iconVisible, label, disabled, onClick }: Props) => {
  const linkColor = disabled ? 'grey600' : iconVisible ? 'viridian1000' : 'grey800'

  return (
    <Box flexDirection="row" gap="s8">
      <Box
        style={{
          visibility: iconVisible ? 'visible' : 'hidden',
        }}
      >
        <Icon.Medium icon="check" color="viridian1000" />
      </Box>
      <Box
        flexDirection="row"
        gap="s4"
        onClick={disabled ? undefined : onClick}
        alignItems="center"
      >
        <Text.Normal color={linkColor}>{label}</Text.Normal>
        <Icon.Small icon="arrow-right" color={linkColor} />
      </Box>
    </Box>
  )
}

export default NavigationLink
